import * as Comlink from 'comlink';

interface Clock {
    subscribe: (cb: (date: Date) => void) => void;
}

const workerBaseUrl = import.meta.env.DEV ? window.location.origin : import.meta.env.VITE_HOME_ROUTE;

const worker = new SharedWorker(new URL('worker.js', workerBaseUrl), {
    name: 'ClockWorker',
});

const clock = Comlink.wrap<Clock>(worker.port);

export default clock;
